import { PlayerSummary } from '@inplay/models';
import { FormPlayerData } from '../component/harmReportForm/harmReportForm.types';
import { NewPlayerImages } from '../component/selectPlayerModal/selectPlayerModal.types';

export const createFormPlayerDataFromExistingPlayer = (
  player: PlayerSummary,
): FormPlayerData => {
  const formPlayerData: FormPlayerData = {
    id: player.playerId,
    faceImage: player.faceImage || '',
    bodyImage: player.fullImage || '',
    faceImageId: `players/face_${player.playerId}_${player.lastEventId}.jpeg`,
    bodyImageId: `players/full_${player.playerId}_${player.lastEventId}.jpeg`,
    description: player.description,
    currentUninterruptedTime: player.currentUninterruptedTime,
    minutesInGamingRoom: player.minutesInGamingRoom,
    minutesOutsideGamingRoom: player.minutesOutsideGamingRoom,
    totalWithdrawals: player.totalWithdrawals,
  };
  return formPlayerData;
};

export const createFormPlayerDataFromNewPlayer = (
  images: NewPlayerImages,
): FormPlayerData => {
  const formPlayerData: FormPlayerData = {
    id: '',
    faceImage: images.portraitImage,
    bodyImage: images.fullBodyImage,
  };
  return formPlayerData;
};
